function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M340,409.3V109.7c0-22.8-18.8-41.4-41.6-41.4H257v-19c0-5.5-4.9-10-10.4-10h-31.3c-7.3-19-25.6-31.4-46.1-31.4 c-20.4,0-38.4,12.4-46,31.4H92.3c-5.5,0-10.3,4.4-10.3,10v19H41.1C18.2,68.3,0,86.9,0,109.7v299.6c0,22.8,18.2,41,41.1,41h257.3 C321.2,450.3,340,432.2,340,409.3z M102,59.3h28.5c4.6,0,8.7-3.2,9.7-7.7c3.3-14.2,15-23.7,29-23.7s26.1,9.9,28.9,23.4 c1,4.6,5,8,9.8,8H237v45H102V59.3z M20,409.3V109.7c0-11.8,9.3-21.4,21.1-21.4H82v26.3c0,5.5,4.8,9.7,10.3,9.7h154.3 c5.5,0,10.4-4.2,10.4-9.7V88.3h41.4c11.8,0,21.6,9.6,21.6,21.4v299.6c0,11.8-9.8,21-21.6,21H41.1C29.3,430.3,20,421.1,20,409.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1,296.2c2,2,4.6,3,7.2,3c2.5,0,4.9-0.9,6.9-2.7L129,258c4-3.8,4.2-10.1,0.4-14.1s-10.1-4.2-14.1-0.4l-33.6,31.8 l-14.6-15c-3.8-4-10.2-4.1-14.1-0.2c-4,3.8-4.1,10.2-0.2,14.1L74.1,296.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M281.3,266.3H161c-5.5,0-10,4.5-10,10s4.5,10,10,10h120.3c5.5,0,10-4.5,10-10S286.8,266.3,281.3,266.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1,212.5c2,2,4.6,3,7.2,3c2.5,0,4.9-0.9,6.9-2.7l40.8-38.5c4-3.8,4.2-10.1,0.4-14.1s-10.1-4.2-14.1-0.4l-33.6,31.8 l-14.5-14.9c-3.8-4-10.2-4.1-14.1-0.2c-4,3.8-4.1,10.2-0.2,14.1L74.1,212.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M281.3,182.3H161c-5.5,0-10,4.5-10,10s4.5,10,10,10h120.3c5.5,0,10-4.5,10-10S286.8,182.3,281.3,182.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M281.3,350.3H161c-5.5,0-10,4.5-10,10s4.5,10,10,10h120.3c5.5,0,10-4.5,10-10S286.8,350.3,281.3,350.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M93.7,312.6c-23.2,0-42,18.9-42,42.1s18.8,42,42,42s42.1-18.8,42.1-42C135.7,331.4,116.9,312.6,93.7,312.6z M93.7,376.6 c-12.1,0-22-9.9-22-22c0-12.2,9.9-22.1,22-22.1c12.2,0,22.1,9.9,22.1,22.1C115.7,366.8,105.9,376.6,93.7,376.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M458,139.4c0-25.7-20.9-46.1-46.6-46.1h-9.2c-25.7,0-46.3,20.4-46.3,46.1v18l-0.4,210.2c0,1.9,0.4,3.7,1.4,5.3l41.4,66.5 c1.8,2.9,5,4.9,8.4,4.9l0,0c3.4,0,6.6-2,8.5-4.9l41.5-66.3c1-1.6,1.5-3.5,1.5-5.4L458,157.4V139.4z M381.8,167.3l-0.2,190h-6.2 l0.2-190H381.8z M401.8,167.3h10.1l0.3,190h-10.6L401.8,167.3z M432.1,357.3l-0.3-190h6.2l0.2,190H432.1z M402.3,113.3h9.2 c14.7,0,26.6,11.4,26.6,26.1v7.9h-62v-7.9C376,124.7,387.6,113.3,402.3,113.3z M406.8,414.7l-23.3-37.4h46.8L406.8,414.7z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

function SvgClipboardTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.2 458.2",
    style: {
      enableBackground: "new 0 0 458.2 458.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC75B"
    },
    points: "449.1,156.4 449.3,366.6 423.2,366.6 422.8,156.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC75B"
    },
    points: "449.3,366.6 407.8,432.8 366.4,366.6 392.6,366.6 423.2,366.6  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED664C"
    },
    d: "M449.1,138.4v18h-26.2h-30h-26.2v-18c0-20.2,16.4-36.6,36.6-36.6h9.2 C432.6,101.8,449.1,118.2,449.1,138.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC75B"
    },
    points: "422.8,156.4 423.2,366.6 392.6,366.6 392.8,156.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC75B"
    },
    points: "392.8,156.4 392.6,366.6 366.4,366.6 366.7,156.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC75B"
    },
    d: "M330.8,108.7v299.6c0,17.4-14,31.4-31.4,31.4H42.1c-17.3,0-31.4-14-31.4-31.4V108.7 c0-17.4,14.1-31.4,31.4-31.4h48.1h3.1v36.3h154.3V77.3h51.8C316.8,77.3,330.8,91.3,330.8,108.7z M126.7,353.6 c0-17.7-14.4-32.1-32.1-32.1s-32,14.4-32,32.1s14.3,32,32,32S126.7,371.3,126.7,353.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED664C"
    },
    d: "M247.6,77.3v36.3H93.3V77.3v-29h38.2c4.2-17.8,19.4-31.4,38.7-31.4s35,13.6,38.7,31.4h38.7V77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED664C"
    },
    d: "M94.7,321.6c17.7,0,32.1,14.4,32.1,32.1s-14.4,32-32.1,32s-32-14.3-32-32S77,321.6,94.7,321.6z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTest);
export default __webpack_public_path__ + "static/media/clipboard-test.d348af88.svg";
export { ForwardRef as ReactComponent };